var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9753C0 16.2471 0.105357 16.5077 0.292893 16.6999C0.48043 16.8921 0.734784 17 1 17H13C13.2652 17 13.5196 16.8921 13.7071 16.6999C13.8946 16.5077 14 16.2471 14 15.9753C14 15.7036 13.8946 15.443 13.7071 15.2508C13.5196 15.0586 13.2652 14.9507 13 14.9507H1C0.734784 14.9507 0.48043 15.0586 0.292893 15.2508C0.105357 15.443 0 15.7036 0 15.9753Z",
    fill: "#323338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 6.14801L11.5901 6.14801C11.7879 6.14886 11.981 6.20979 12.145 6.32308C12.309 6.43637 12.4365 6.59694 12.5114 6.78448C12.5863 6.97203 12.6053 7.17813 12.5659 7.37672C12.5265 7.57532 12.4306 7.75749 12.2901 7.90019L7.70013 12.6034C7.51277 12.7942 7.25932 12.9014 6.99513 12.9014C6.73094 12.9014 6.47749 12.7942 6.29013 12.6034L1.70013 7.90019C1.5591 7.75687 1.46292 7.57376 1.42385 7.37421C1.38478 7.17466 1.40459 6.96771 1.48076 6.77974C1.55693 6.59177 1.686 6.4313 1.85152 6.31879C2.01704 6.20628 2.21151 6.14683 2.41013 6.14801L4.00013 6.14801L4.00013 1.02469C4.00013 0.752933 4.10549 0.492306 4.29302 0.300144C4.48056 0.107983 4.73491 2.60165e-05 5.00013 2.60397e-05L9.00013 2.63894e-05C9.26535 2.64126e-05 9.5197 0.107983 9.70724 0.300145C9.89477 0.492306 10.0001 0.752933 10.0001 1.02469L10.0001 6.14801Z",
    fill: "#323338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.6583e958a77fae2877774a21508d5d36.svg";
export { ForwardRef as ReactComponent };